var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"corps"}},[_c('v-app',[_c('router-view'),_c('v-snackbar',{attrs:{"value":_vm.isMockApi,"color":"warning","right":"","timeout":-1}},[_vm._v("Mock API activé.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }